import script from "./systemTicket.vue?vue&type=script&setup=true&lang=js"
export * from "./systemTicket.vue?vue&type=script&setup=true&lang=js"

import "./systemTicket.vue?vue&type=style&index=0&id=4e332e28&lang=css"

const __exports__ = script;

export default __exports__